import { FormikHelpers, FormikValues } from "formik";
import { ApolloError } from "@apollo/client";
import { navigate } from "@reach/router";
import { Roles } from "components/auth/types";
import logger from "services/logger";

type Actions = FormikHelpers<FormikValues>;

// options for select component
export type ListOption = {
  id: string;
  label: string;
}

// NOTE this is the data shape/format coming out of the form, not the user object
export interface UserFormData {
  firstName: string;
  lastName: string;
  email: string;
  roles: Roles | "";
  lists: ListOption[];
  organizationId: string | null;
  directPhone: string | null;
  title: string | null;
}

// -- helper functions --

export const handleSubmitError = (mutationType: string) => (err: ApolloError) => {
  logger.sendError(err);
  // eslint-disable-next-line no-alert
  alert(
    `Unable to ${mutationType.toLowerCase()} this user, please contact support@havenconnect.com`,
  );
};

export const handleResponse = (actions: Actions) => (_res: any) => {
  actions.setSubmitting(true);
  actions.resetForm();
  navigate("/dash/manager/settings/team");
};

const formatRoles = (formRole: Roles | "") => {
  if (formRole === Roles.Supervisor) {
    return [Roles.PropertyManager, Roles.Supervisor];
  }
  return [formRole];
};

type CleanOutputType = {
  firstName: string;
  lastName: string;
  email: string;
  roles: (Roles | "")[];
  lists: {
    id: string;
    name: string;
  }[];
  organizationId: string | null;
  directPhone: string | null;
  title: string | null;
}

export const cleanUserFormOutput = (values: UserFormData):CleanOutputType => ({
  firstName: values.firstName.trim(),
  lastName: values.lastName.trim(),
  email: values.email.trim().toLowerCase(),
  roles: formatRoles(values.roles),
  lists: values.lists.map(({ id, label }: ListOption) => ({ id, name: label })),
  organizationId: values.organizationId,
  directPhone: values.directPhone,
  title: values.title,
});
